import { createSlice } from '@reduxjs/toolkit';
import { mapPosition } from '../../utilities/mapResponse';

const initialState = { positions: [], positionArray: [] };
const positionSlice = createSlice({
  name: 'positions',
  initialState,
  reducers: {
    setPositions(state, action) {
      state.positions = mapPosition(action.payload);
    },
    setPositionArray(state, action) {
      state.positionArray = action.payload;
    },
    appendPosition(state, action) {
      state.positions = [...state.positions, ...mapPosition([action.payload])];
      state.positionArray = [...state.positionArray, ...[action.payload]];
    },
    updatePosition(state, action) {
      const updatedPosition = mapPosition([action.payload])[0];
      state.positions = state.positions.map(pos => 
        pos.position === updatedPosition.position ? updatedPosition : pos
      );
      state.positionArray = state.positionArray.map(pos => 
        pos[0] === action.payload[0] ? action.payload : pos
      );
    },
    deletePosition(state, action) {
      const posIds = Array.isArray(action.payload) ? action.payload : [action.payload];
      state.positions = state.positions.filter(pos =>
        pos && !posIds.includes(pos.position)
      );
      state.positionArray = state.positionArray.filter(pos =>
        pos && pos[0] && !posIds.includes(pos[0])
      );
    }
  }
});

export const { setPositions, appendPosition, updatePosition, deletePosition, setPositionArray } = positionSlice.actions;

const positionReducer = positionSlice.reducer;
export default positionReducer;